/**UTILIZADO NAS TELAS ONDE USARAM O COMPONENTE*/

import defaultEmbeddableMixin from "@/mixins/embeddable/resource/defaultEmbeddableMixin";
import ui from "@/assets/scripts/ui";

export default {

    mixins: [defaultEmbeddableMixin],
    data() {
        return {
            command: 'insert',
            pageFormIsLoaded: false,
            enabledSubmit: false,
            setFieldCustomized: [] //Utilizado para enviar uma customização de campos para ser setado de fora
        }
    },
    methods: {

        responseErrorGeneral(error) {

            if (error.response) {

                if (error.response.status === 500) {

                    const general = error.response.data.general

                    if (general && general.length > 0) {

                        let errors = ""

                        for (error of general) {
                            errors += " - " + error
                        }

                        ui.msgError(this,errors)

                    }


                } else if (error.response.status === 400) {

                    alert('Falha ao tentar enviar, por favor tente novamente ou informe nosso suporte técnico o seguinte erro: 400')
                    console.warn(error.response);

                }

            } else if (error.request) {
                // The request was made but no response was received
                alert('Falha de conexão, verifique sua internet 4')
                console.warn(error.request);
            }

        },

        onMountedForm(userAuth, command) {

            this.userAuth = userAuth
            this.command = command

            //Chama o mountedContinued interno
            this.mountedContinued()

        },

        getFieldValue(entity, fieldId) {

            if (this.$refs.embeddable && this.$refs.embeddable.fieldsCustomizable !== undefined) {

                const entityField = this.$refs.embeddable.fieldsCustomizable.find(a => a.entity === entity)

                if (entityField !== undefined) {

                    let field = entityField.fields.find(a => a.fieldId === fieldId)
                    if (field !== undefined)
                        return field.value

                }

            }


        },

        /*ATENÇÃO ESTE AQUI É DIFERENTE POIS É ACESSADO VIA REFS INDIRETAMENTE*/
        setFieldValue(entity, fieldId, value) {

            if (this.$refs.embeddable && this.$refs.embeddable.fieldsCustomizable !== undefined) {

                let entityField = this.$refs.embeddable.fieldsCustomizable.find(a => a.entity === entity)

                if (entityField !== undefined) {

                    let field = entityField.fields.find(a => a.fieldId === fieldId)

                    if (field !== undefined) {

                        field.value = value
                        entityField.fields.push(field)
                        entityField.fields.pop()

                    }

                }

            }

        },

    }
}